var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"publish-product"},[_c('page-wrapper',{attrs:{"title":"发布产品"}},[_c('div',{staticClass:"publish-product-inner"},[_c('div',{staticClass:"publish-product-title"},[_vm._v("选择类目")]),_c('switch-cate')],1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }